const tierChip = (backgroundColor, color) => ({
  fontWeight: 600,
  height: 22,
  backgroundColor,
  color,
});

const styles = (theme) => ({
  high: tierChip(theme.palette.success.light, theme.palette.success.dark),
  medium: tierChip(theme.palette.warning.light, theme.palette.warning.dark),
  low: tierChip('#FBE9E7', theme.palette.error.dark),
  none: {},
});

export default styles;
